<template>
    <button
        type="button"
        class="patient-ai-summarize"
        :class="{ small: small }"
        @click="$emit('click')"
    >
        <i class="fas fa-hat-wizard"></i>
        <span>Summarize</span>
    </button>
</template>

<script>
export default {
    props: {
        small: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style lang="scss" scoped>
button {
    border: none;
    padding: 3px 10px;
    display: flex;
    align-items: center;
    gap: 5px;
    border-radius: 6px;
    border: 1px solid #a0a1ad;
    background: linear-gradient(180deg, #e7e7e7, #f7f7f7);
    box-shadow: inset 0px 1px 0 #ffffff;
    font-weight: 500;
    outline: none;

    &:hover {
        border: 1px solid #56782b;
        background: #e1ead4;
    }
}
</style>
